import {Component, Fragment} from "react";
import * as React from "react";
import {CommandBarButton, MessageBar, MessageBarButton, MessageBarType} from "office-ui-fabric-react";
import GroundFloorDurableFunctionInstanceList from "./GroundFloorDurableFunctionInstanceList";
import Actions from "../redux/Actions";
import {friendlySchoolName} from "../utils/Utils";
import {connect} from "react-redux";
import {IRootState} from "../store";
import {GroundFloorDurableFunctionInstance} from "../models/DurableFunctionInstance";
import ApiService from "./ApiService";
import School from "../models/School";
import DispatchProps from "../utils/DispatchProps";
import {buildIndexedSchools} from "../utils/IndexedSchools";

interface SyncSubjectsAndYearsPromptProps
{
    school: School;
    message: string;
    apiService: ApiService;
}

interface SyncSubjectsAndYearsPromptState
{
    showSyncSubjectsMessageBar: boolean;
    syncSubjectsWorkloadInstance?: GroundFloorDurableFunctionInstance
}

class SyncSubjectsAndYearsPrompt extends Component<SyncSubjectsAndYearsPromptProps & DispatchProps,SyncSubjectsAndYearsPromptState>
{
    constructor(props: SyncSubjectsAndYearsPromptProps & DispatchProps) {
        super(props);

        this.state = {
            showSyncSubjectsMessageBar: true,
            syncSubjectsWorkloadInstance: undefined
        };

    }
    
    private triggerSyncSubjectsWorkload = async () => {
        if(this.props.school === undefined)
        {
            return;
        }

        const workloadInstance = await this.props.apiService.triggerWorkload(this.props.school, "SyncSubjectsAndYears");
        await this.props.dispatch(Actions.showMessageBar(`Started SyncSubjectsAndYears for ${friendlySchoolName(this.props.school)}`, MessageBarType.success));
        this.setState({
            syncSubjectsWorkloadInstance: workloadInstance,
            showSyncSubjectsMessageBar: false
        })
    }
    
    private refreshSyncSubjectsWorkload = async () => {
        if(this.state.syncSubjectsWorkloadInstance === undefined)
        {
            return;
        }
        const updatedWorkloadInstance = await this.props.apiService.getGroundFloorDurableFunctionInstance(this.state.syncSubjectsWorkloadInstance.durableFunctionInstanceId);
        this.setState({
            syncSubjectsWorkloadInstance: updatedWorkloadInstance
        })
    }

    private buildSyncSubjectsWorkloadInstanceList() : JSX.Element
    {
        const refreshButton = (
            <CommandBarButton
                iconProps={{iconName: "Refresh"}}
                text="Refresh"
                onClick={this.refreshSyncSubjectsWorkload}
            />
        );
        const indexedSchools = buildIndexedSchools([this.props.school]);

        return (
            <GroundFloorDurableFunctionInstanceList title={"Sync Subjects"} instances={[this.state.syncSubjectsWorkloadInstance!]} indexedSchools={indexedSchools} enableRowLinks={true} openRowLinksInNewTab={true} headerExtra={refreshButton}/>
        );
    }
    
    public componentDidMount() {

    }

    public render() {

        const triggerWorkloadAction = <MessageBarButton onClick={this.triggerSyncSubjectsWorkload}>Trigger SyncSubjectsAndYears Workload</MessageBarButton>;
        
        return (
            <Fragment>
                <div className="p-top-1rem p-left-1rem p-right-1rem" style={{display: this.state.showSyncSubjectsMessageBar ? "block" : "none"}}>
                    <MessageBar messageBarType={MessageBarType.warning} actions={triggerWorkloadAction} onDismiss={() => {
                        this.setState({
                            showSyncSubjectsMessageBar: false
                        });
                    }}>
                        {this.props.message}
                    </MessageBar>
                </div>

                {this.state.syncSubjectsWorkloadInstance ? this.buildSyncSubjectsWorkloadInstanceList() : null}
            </Fragment>
        );
    }
}

export default connect(
    (state: IRootState,ownProps: {school: School, message: string}): SyncSubjectsAndYearsPromptProps => {
        return {
            school: ownProps.school,
            message: ownProps.message,
            apiService: state.auth.apiService
        };
    }
)(SyncSubjectsAndYearsPrompt)